import { AxiosResponse } from 'axios';
import { getRemoteOrLocal } from '../globals/cache';
import { session } from '../globals/session';
import { StorableBaseService } from './_base';

// import store from '../store/state'

// import defaultSettingsService from '../services/settings-defaults';


interface Institution {
    id: string;
    created_at: string;
    modified_at: string;
    onboarded_at?: string;
    name: string;
    flags: Array<string>;
    config: any;

    contact_person: string;
    address: string;
    number: string;
    address_2: string;
    zip_code: string;
    city: string;
    country: string;
    invoice_email_address?: string;
    brand: string;

    terminal_pin: string;
}


class InstitutionService extends StorableBaseService<Institution> {

    cachedDefaultSettings: any = undefined;
    isInitialised = false;

    constructor() {
        super("/api/v2/accounts/institutions/");
        this.cacheTimeout = 60 * 15;
    }

    // initialise(): Promise<void> {
    //     return Promise.all([
    //         defaultSettingsService.list(),
    //         this.retrieveSettings(store.AppActiveUser.institutionId)
    //     ]).then(function (this: any, settings: any) {
    //         let defaultSettings: any = {};
    //         for (let category of settings[0]) {
    //             defaultSettings[category.id] = {};
    //             for (let setting of category.settings) {
    //                 defaultSettings[category.id][setting.id] = setting.id;
    //             }
    //         }
    //         this.cachedDefaultSettings = defaultSettings;

    //         this.cachedInstitutionSettings[store.AppActiveUser.institutionId] = settings[1];
    //         this.isInitialised = true;
    //     }.bind(this))
    // }

    async retrieveSettings(institutionId?: string, onFresh?: (result: AxiosResponse<any>) => void): Promise<AxiosResponse<any>> {
        institutionId = institutionId || session.getInstitution().id;
        // onFresh: cache-first re-render callback — cached settings are served
        // first, then this fires with the live server state (see getRemoteOrLocal).
        return getRemoteOrLocal<any>(
            'store/accounts/institutions/settings-historical',
            this._get.bind(this), institutionId + "/settings-historical/", onFresh);
    }

    async retrieveSettingEntry(categoryId: string, settingId: string, contextDateUtc?: string): Promise<any> {
        if (!contextDateUtc) contextDateUtc = (new Date()).toISOString();

        const response = await this.retrieveSettings();
        if (!response) return;

        const settings = response.data;
        if (!settings?.[categoryId]?.[settingId]) return undefined;
        if (!settings?.[categoryId]?.[settingId]) return;


        for (const item of settings[categoryId][settingId]) {
            if (item.valid_from <= contextDateUtc && (!item.valid_before || contextDateUtc < item.valid_before)) {
                return item;
            }
        }
    }

    async retrieveSettingValue(categoryId: string, settingId: string, contextDateUtc?: string): Promise<any> {
        const entry = await this.retrieveSettingEntry(categoryId, settingId, contextDateUtc);
        return entry?.value;
    }

    async updateSettings(newSettings: any): Promise<AxiosResponse<any>> {
        const institutionId = session.getInstitution().id;
        return this._post(institutionId + "/settings/", newSettings);
    }

    async getBillingAddress(): Promise<AxiosResponse<any>> {
        const institutionId = session.getInstitution().id;
        return this._get(institutionId + "/billing-address/");
    }

    async onboarded(): Promise<AxiosResponse<any>> {
        const institutionId = session.getInstitution().id;
        return this._post(institutionId + "/onboarded/", {});
    }
}

const institutionService = new InstitutionService();

export { institutionService, InstitutionService, Institution }

export default institutionService;
